<template>
    <div class="ku-goods-success">
        <div class="top">
            <img class="logo" src="../../assets/thank.png" style="object-fit: cover" alt="thank you">
            <span v-show="info.order_no" class="number" v-if="info.pack === 1 || info.pack === 2">{{ info.order_no }}</span>
            <span v-show="info.order_no" class="name" v-if="info.pack === 1">取餐号</span>
            <span v-show="info.order_no" class="name" v-if="info.pack === 2">外带取餐号</span>
            <div class="source_mid0" v-if="info.source_mid === 0">
                <span>长按查订单</span>
                <img src="@/assets/qrcode.jpg" style="object-fit: cover" alt="qrcode">
                <label>{{ info.shop_name }}</label>
            </div>

            <div class="source_mid-title" v-if="info.source_mid === 1">长按关注即送30元券</div>
            <div class="source_mid0" v-if="info.source_mid === 1">
                <span>长按查订单</span>
                <img src="@/assets/qrcode.jpg" style="object-fit: cover" alt="qrcode">
                <label>{{ info.shop_name }}</label>
            </div>

        </div>
        <van-button type="info" @click="onClick">确定</van-button>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Image as VanImage, Button } from 'vant';
    import {getCookie, setCookie} from '@/utils/auth'
    import {UrlSearch} from "@/utils/fu";

    Vue.use(VanImage).use(Button);
    export default {
        name: "index",
        data() {
            return {
                coType: 0,
                no: '',
                info: []
            }
        },
        mounted() {
            this.coType = getCookie('coType');

            let href = new UrlSearch();
            this.no = href.no;
            this.onLoad()
        },
        methods: {
            onLoad() {
                let that = this
                this.$API.orderPayStatus({no: that.no}).then(res => {
                    return res;
                }).then(res => {
                    that.info = res.data.data;
                    setCookie('cart_' + that.info.shop_id);
                    setCookie('shop_number_' + that.info.shop_id, 0)
                })
            },
            onClick() {
                this.$router.push({
                    path: '/order'
                })
            },
        },
    }
</script>

<style lang="less" scoped>
.ku-goods-success {
    height: 100%;
    width: 100%;
    position: fixed;
    background: #F7F7F7;
    .top {
        width: 80%;
        height: auto;
        border: 1px solid #F0DAB3;
        border-radius: 15px;
        background: white;
        padding: 30px 15px;
        margin: 30px auto;
        .logo {
            width: 100%;
        }
        .qrcode {
            width: 50%;
        }
        span{
            display: block;
            color: #D42D27;
            &.number {
                font-size: 150px;
                font-weight: bold;
                padding-top: 30px;
            }
            &.name {
                font-size: 30px;
            }
        }
        .source_mid0 {
            width: 320px;
            margin: 30px auto;
            padding: 30px 10px;
            border: 1px solid #ed891e;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            text-align: center;
            img {
                width: 260px;
                height: 260px;
                margin: 0 auto;
            }
            span, label {
                font-size: 45px;
                font-family: "Microsoft YaHei", serif;
                font-weight: bold;
            }
            label {
                font-weight: normal;
            }
        }

        .source_mid-title {
            width: 70%;
            height: 60px;
            line-height: 60px;
            font-size: 35px;
            background: #ff0000;
            color: #FFFF00;
            text-align: center;
            border-radius: 20px;
            font-weight: bold;
            margin: 30px auto 10px auto;
            padding: 0 10px;
        }
        .source_mid1 {
            width: 70%;
            margin: 0 auto;
            padding: 10px;
            border: 1px solid #ed891e;
            border-radius: 10px;
            display: flex;
            flex-direction: row;
            img {
                width: 110px;
                height: 110px;
            }
            span, label {
                font-size: 40px;
                font-family: "Microsoft YaHei", serif;
                font-weight: bold;
            }
        }
    }
    &>.van-button {
        background: #3C834B;
        border-color: #3C834B;
        width: 185px;
        height: 70px;
        border-radius: 8px;
        font-size: 32px;
    }
}
</style>
